import { useState, useEffect } from 'react';
import BillingServices from '../services/BillingServices';

export const useBilling = () => {
  const [billings, setBillings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchBillings = async () => {
    try {
      setLoading(true);
      const response = await BillingServices.getAllBillings();
      setBillings(response.data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const createBilling = async (billingData) => {
    try {
      setLoading(true);
      const response = await BillingServices.createBilling(billingData);
      setBillings((prev) => [...prev, response]);
      setError(null);
      return response;
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };
  const updateBilling = async (id, billingData) => {
    try {
      setLoading(true);
      const response = await BillingServices.updateBilling(id, billingData);
      setBillings((prev) =>
        prev.map((billing) => (billing.id === id ? response : billing))
      );
      setError(null);
      return response;
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };
  const deleteBilling = async (id) => {
    try {
      setLoading(true);
      await BillingServices.deleteBilling(id);
      setBillings((prev) => prev.filter((billing) => billing.id !== id));
      setError(null);
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    } finally {
      setLoading(false);
    }
  };
  const generateInvoice = async (id) => {
    try {
      setLoading(true);
      const response = await BillingServices.generateInvoice(id);
      setError(null);
      return response;
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchBillings();
  }, []);
  return {
    billings,
    loading,
    error,
    createBilling,
    updateBilling,
    deleteBilling,
    generateInvoice,
  };
}